import React, { useState } from 'react';
import Modal from 'react-bootstrap/Modal';
import Box from '../../components/layout/Box';
import Text from '../../components/Text';
import Form from 'react-bootstrap/Form';
import { useDispatch, useSelector } from 'react-redux';
import { setValue } from '../../state/cookieSettings/actions';
import Button from '../../components/Button';

function CookieSettingsModal({ show, setShow }) {
  const handleClose = () => setShow(false);

  const value = useSelector((state) => state.cookieSettings.value);
  const asked = useSelector((state) => state.cookieSettings.asked);

  const [on, setOn] = useState(!asked ? true : value === 'all');

  const dispatch = useDispatch();

  const handleToggle = () => {
    setOn((prev) => !prev);
  };

  const save = () => {
    if (!on) {
      dispatch(setValue('necessary'));
    } else {
      dispatch(setValue('all'));
    }

    setShow(false);
  };

  return (
    <>
      <Modal size="lg" show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>Inställningar för kakor (cookies)</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Box className="flex-column">
            <Box className="flex-row justify-content-between flex-grow-1">
              <Box>
                <Text>1. Nödvändiga kakor</Text>
              </Box>
              <Box>
                <Form>
                  <Form.Check // prettier-ignore
                    disabled
                    type="switch"
                    checked
                    id="disabled-custom-switch"
                  />
                </Form>
              </Box>
            </Box>
            <Text
              className="mt-1"
              style={{
                fontSize: 14,
              }}
            >
              Dessa kakor är avgörande för att webbplatsen ska fungera korrekt.
              De inkluderar kakor som möjliggör grundläggande funktionalitet,
              såsom navigering på sidan och åtkomst till säkra områden. Utan
              dessa kakor skulle webbplatsen inte fungera som den ska.
            </Text>
          </Box>

          <Box className="flex-column mt-3">
            <Box className="flex-row justify-content-between flex-grow-1">
              <Box>
                <Text>2. Spårningskakor för statistik & marknadsföring</Text>
              </Box>
              <Box>
                <Form>
                  <Form.Check // prettier-ignore
                    type="switch"
                    checked={on}
                    onChange={handleToggle}
                    id="disabled-custom-switch"
                  />
                </Form>
              </Box>
            </Box>
            <Text
              className="mt-1"
              style={{
                fontSize: 14,
              }}
            >
              Vi använder även tredjepartscookies, inklusive Google Analytics 4,
              för att samla in anonym statistik om hur du använder vår
              webbplats. Google Analytics 4 hjälper oss att analysera
              besökarbeteende och förbättra användarupplevelsen. Dessa cookies
              gör det också möjligt för oss att visa dig annonser som är
              relevanta för dina intressen.
            </Text>
          </Box>
        </Modal.Body>
        <Modal.Footer>
          <Button onClick={save}>Spara</Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default CookieSettingsModal;
